import { render, staticRenderFns } from "./MobilePreventionHealthRequestCreate.vue?vue&type=template&id=927ffb06&scoped=true&"
import script from "./MobilePreventionHealthRequestCreate.vue?vue&type=script&lang=js&"
export * from "./MobilePreventionHealthRequestCreate.vue?vue&type=script&lang=js&"
import style0 from "./MobilePreventionHealthRequestCreate.vue?vue&type=style&index=0&id=927ffb06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927ffb06",
  null
  
)

export default component.exports